import React, {
	ReactElement,
	useContext,
	useEffect,
	useMemo,
	useState,
} from 'react';
import {
	Rectangle,
	TileLayer,
	useMap,
	useMapEvent,
	useMapEvents,
} from 'react-leaflet';
import { Place } from '../../models/Place';
import 'leaflet/dist/leaflet.css';
import L, { LatLng, LatLngBounds } from 'leaflet';
import { MapContainerStyled } from './mapStyles';
import 'leaflet-polylinedecorator';
import { useIonViewDidEnter } from '@ionic/react';
import { PlaceList } from '../../models/factories/PlaceFactory';
import { AONB_Bounds, ExplorerContext } from '../../application/config';
import { useAppSelector } from '../../state/hooks';
import { RootState } from '../../state/store';
import MapController from '../Mapping/MapController';
import LocationMarker from '../Mapping/LocationMarker';
import MapHomeButton from '../Mapping/MapHomeButton';
import PlaceMarkers from '../Mapping/PlaceMarkers';
import TrailMarkers from '../Mapping/TrailMarkers';
import { render } from '@testing-library/react';
import MapToasts from '../Global/DumbMap/subComponents/MapToasts/MapToasts';
import { IPlace } from '../../models/interfaces/IPlace';
import StoryPlaceMarkers from '../Mapping/StoryPlaceMarkers';
import StoryMapController from '../Mapping/StoryMapController';

type MapProps = {
	places: IPlace[];
};

function StoryPlacesMap({ places }: MapProps): ReactElement {
	const currentLat = useAppSelector(
		(state: RootState) => state.location.latitude,
	);
	const currentLng = useAppSelector(
		(state: RootState) => state.location.longitude,
	);
	const current_location = useMemo(
		() => new LatLng(currentLat, currentLng),
		[currentLat, currentLng],
	);

	const allPlaces: Place[] = places as Place[];

	useIonViewDidEnter(() => {
		window.dispatchEvent(new Event('resize'));
	});

	return (
		<>
			<MapContainerStyled
				id="storyPlaceMap"
				className="fullMap"
				center={AONB_Bounds.getNorthWest()}
				minZoom={8}
				maxZoom={15}
				zoom={12}
				dragging={false}
				zoomControl={false}
				doubleClickZoom={false}
				scrollWheelZoom={false}
				attributionControl={false}>
				<>
					<StoryMapController places={allPlaces} />
					<TileLayer
						attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
					{/*<Rectangle bounds={AppData.boundary} />*/}
					<LocationMarker />
					<StoryPlaceMarkers places={allPlaces} />
				</>
			</MapContainerStyled>
		</>
	);
}

export default StoryPlacesMap;
